import { Currency } from "@goodfill/domain-properties";
import React from "react";
import { AccountBondHolding } from "../../../AccountHolding";
import { PortfolioHoldingsTable } from "./PortfolioHoldingsTable";
import { PresentedAccountBondHolding } from "./PresentedAccountBondHolding";

interface Props {
  bondHoldings: AccountBondHolding[];
  currency: Currency;
}

export const PortfolioHoldingsSection: React.FC<Props> = ({ bondHoldings, currency }) => {
  const rows: PresentedAccountBondHolding[] = bondHoldings.map((holding) => {
    const pricedBond = holding.pricedBond;

    return {
      bondId: pricedBond.bondIdCusip,
      ticker: pricedBond.issuerTicker,
      couponPayment: pricedBond.couponPayment,
      maturityDate: pricedBond.maturityDate,
      issuerName: pricedBond.issuerName,
      issuerId: pricedBond.issuerId,
      paymentRank: pricedBond.paymentRank,
      balance: holding.bondBalanceAccount.balance,
      bidBondValue: holding.getBondValue("bid"),
      bondRatingMoodys: pricedBond.ratings.moodys,
      bondRatingSp: pricedBond.ratings.sp,
      isin: pricedBond.isin,
      baseBondBidYield: pricedBond.bidYield,
      baseBondBidPrice: pricedBond.bidPrice,
    };
  });

  return <PortfolioHoldingsTable bondHoldings={rows} currency={currency} />;
};
